// Funções de validação de CPF/CNPJ para o frontend
export function validateCpf(cpf: string): boolean {
  const cleanCpf = cpf.replace(/[^\d]/g, '');

  if (cleanCpf.length !== 11) return false;

  // Verificar se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cleanCpf)) return false;

  // Calcular primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleanCpf[i]) * (10 - i);
  }
  let remainder = (sum * 10) % 11;
  let digit1 = remainder === 10 || remainder === 11 ? 0 : remainder;

  // Calcular segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleanCpf[i]) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  let digit2 = remainder === 10 || remainder === 11 ? 0 : remainder;

  return parseInt(cleanCpf[9]) === digit1 && parseInt(cleanCpf[10]) === digit2;
}

export function validateCnpj(cnpj: string): boolean {
  const cleanCnpj = cnpj.replace(/[^\d]/g, '');

  if (cleanCnpj.length !== 14) return false;

  // Verificar se todos os dígitos são iguais
  if (/^(\d)\1{13}$/.test(cleanCnpj)) return false;

  // Calcular primeiro dígito verificador
  let sum = 0;
  let weight = 2;
  for (let i = 11; i >= 0; i--) {
    sum += parseInt(cleanCnpj[i]) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }
  let remainder = sum % 11;
  let digit1 = remainder < 2 ? 0 : 11 - remainder;

  // Calcular segundo dígito verificador
  sum = 0;
  weight = 2;
  for (let i = 12; i >= 0; i--) {
    sum += parseInt(cleanCnpj[i]) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }
  remainder = sum % 11;
  let digit2 = remainder < 2 ? 0 : 11 - remainder;

  return parseInt(cleanCnpj[12]) === digit1 && parseInt(cleanCnpj[13]) === digit2;
}

export function validateCpfCnpj(value: string): boolean {
  const cleanValue = value.replace(/[^\d]/g, '');

  if (cleanValue.length === 11) {
    return validateCpf(cleanValue);
  } else if (cleanValue.length === 14) {
    return validateCnpj(cleanValue);
  }

  return false;
}

export function formatCpfCnpj(value: string): string {
  const cleanValue = value.replace(/[^\d]/g, '');

  if (cleanValue.length === 11) {
    // Formatar CPF: 000.000.000-00
    return cleanValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (cleanValue.length === 14) {
    // Formatar CNPJ: 00.000.000/0000-00
    return cleanValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  return value;
}